import { j as t } from "../../_virtual/jsx-runtime.js";
const a = ({
  width: s = 20,
  height: o = 20,
  viewBox: e = "0 0 20 20",
  fill: r = "currentColor",
  ...n
}) => /* @__PURE__ */ t.jsxs(
  "svg",
  {
    width: s,
    height: o,
    viewBox: e,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...n,
    children: [
      /* @__PURE__ */ t.jsx(
        "path",
        {
          d: "M16.3442 8.0184L11.2437 13.1188L10.0652 11.9403L15.1657 6.83989L11.2437 6.83989L11.2437 5.17323L18.0108 5.17322L18.0108 11.9403L16.3442 11.9403L16.3442 8.0184Z",
          fill: r
        }
      ),
      /* @__PURE__ */ t.jsx(
        "rect",
        {
          x: "11.5538",
          y: "12.8104",
          width: "1.67236",
          height: "6.17383",
          transform: "rotate(135 11.5538 12.8104)",
          fill: r
        }
      ),
      /* @__PURE__ */ t.jsx(
        "rect",
        {
          x: "3.17172",
          y: "14.8268",
          width: "1.67236",
          height: "7.35361",
          transform: "rotate(-135 3.17172 14.8268)",
          fill: r
        }
      )
    ]
  }
);
export {
  a as default
};
